// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CalculationMethods } from "./CalculationMethods";
import {
  CalculationMethodsFromJSON,
  CalculationMethodsFromJSONTyped,
  CalculationMethodsToJSON,
  CalculationMethodsToJSONTyped,
} from "./CalculationMethods";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface BuildingFloodRiskInput
 */
export interface BuildingFloodRiskInput {
  /**
   *
   */
  scenario: RanaFile;
  /**
   *
   */
  buildingsVector: RanaFile;
  /**
   *
   */
  calculationMethod?: CalculationMethods;
  /**
   *
   */
  buildingsVectorLayerName?: any | null;
}

/**
 * Check if a given object implements the BuildingFloodRiskInput interface.
 */
export function instanceOfBuildingFloodRiskInput(value: object): value is BuildingFloodRiskInput {
  if (!("scenario" in value) || value["scenario"] === undefined) return false;
  if (
    (!("buildingsVector" in (value as Record<string, any>)) &&
      !("buildings_vector" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["buildingsVector"] === undefined &&
      (value as Record<string, any>)["buildings_vector"] === undefined)
  )
    return false;
  return true;
}

export function BuildingFloodRiskInputFromJSON(json: any): BuildingFloodRiskInput {
  return BuildingFloodRiskInputFromJSONTyped(json, false);
}

export function BuildingFloodRiskInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BuildingFloodRiskInput {
  if (json == null) {
    return json;
  }
  return {
    scenario: RanaFileFromJSON(json["scenario"]),
    buildingsVector: RanaFileFromJSON(json["buildings_vector"]),
    calculationMethod:
      json["calculation_method"] == null
        ? undefined
        : CalculationMethodsFromJSON(json["calculation_method"]),
    buildingsVectorLayerName:
      json["buildings_vector_layer_name"] === undefined
        ? undefined
        : json["buildings_vector_layer_name"] === null
        ? null
        : json["buildings_vector_layer_name"],
  };
}

export function BuildingFloodRiskInputToJSON(json: any): BuildingFloodRiskInput {
  return BuildingFloodRiskInputToJSONTyped(json, false);
}

export function BuildingFloodRiskInputToJSONTyped(
  value?: BuildingFloodRiskInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    scenario: RanaFileToJSON(value["scenario"]),
    buildings_vector: RanaFileToJSON(value["buildingsVector"]),
    calculation_method: CalculationMethodsToJSON(value["calculationMethod"]),
    buildings_vector_layer_name: value["buildingsVectorLayerName"],
  };
}
